import { ServiceMaker, methods, services } from "@/services";
import Api from "@/services/service-v2";

export const fetchContactEnquiry = (data) =>
    ServiceMaker("/servicerequest/ticket/total-service-request", methods.POST, services.master, data);
export const updateContactEnquiry = (payload) =>
    ServiceMaker(`/servicerequest/ticket/update/${payload.id}`, methods.PUT, services.master, payload.body);